<template>
  <div>
    <footer class="py-5">
      <div class="container">
        <div class="row">
          <div class="col-12 pb-md-5 pb-2 foot-logo text-md-left text-center">
            <img class="img-fluid" src="images/logo/logo-white.webp" alt="logo">
          </div>
          <div class="col-lg-3 quick-link">
            <div class="h5">Beranda</div>
            <ul class="navbar-nav">
              <li class="nav-item pb-1">
                <a href="https://atozpay.co.id/about.html" target="_blank" rel="noopener">Tentang Atozpay</a>
              </li>
              <li class="nav-item py-1">
                <a href="#underconstruction" target="_blank" rel="noopener">Layanan</a>
              </li>
              <li class="nav-item py-1">
                <a href="#underconstruction" target="_blank" rel="noopener">Promo & Blog</a>
              </li>
              <li class="nav-item py-1">
                <a href="https://atozpay.co.id/syaratdanketentuan.html" target="_blank" rel="noopener">Syarat &
                  Ketentuan</a>
              </li>
              <li class="nav-item py-1">
                <a href="https://atozpay.co.id/kebijakan-privasi.html" target="_blank" rel="noopener">Kebijakan
                  Privasi</a>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 mt-lg-0 mt-3">
            <div class="h5">Kantor</div>
            <address>
              Menara Imperium ,<br>
              Lantai LG 11, Metropolitan Kuningan Superblok Kav. No 1, <br>
              Jl. HR. Rasuna Said, <br>
              Jakarta Selatan <br>
              DKI Jakarta 12980
            </address>
          </div>
          <div class="col-lg-3">
            <div class="h5">Kontak</div>
            <p>helpdesk@atozpay.co.id</p>
            <p>for Investor Relation please contact this email address: ir@atozpay.co.id</p>
            <p>+62 21 8354116 / +62 21 8354117</p>
          </div>
          <div class="col-lg-3 btn-download">
            <div class="h5">Unduh</div>
            <div class="mb-md-3 mb-2">
              <a href="https://play.google.com/store/apps/details?id=id.co.weypay" target="_blank" rel="noopener">
                <img class="hvr-grow" src="images/icon/icon-google.webp" alt="playstore"
                  title="go to playstore"></a>
            </div>
            <div class="mb-md-3 mb-2">
              <a href="https://apps.apple.com/id/app/atozpay-isi-pulsa-dan-ppob/id1502051323" target="_blank"
                rel="noopener"><img class="hvr-grow" src="images/icon/icon-apple.webp" alt="appstore"
                  title=" go to appstore"></a>
            </div>
          </div>
        </div>
        <div class="row sosmed py-md-0 pt-2">
          <div class="col-12 text-center justify-content-md-end d-flex">
            <a href="https://www.facebook.com/atozpay/" target="_blank" rel="noopener" class="mr-3">
              <i class="fab fa-facebook fa-2x"></i>
            </a>

            <a href="https://www.instagram.com/atozpay/" target="_blank" rel="noopener">
              <i class="fab fa-instagram fa-2x"></i>
            </a>
          </div>
        </div>
        <hr color="white">
        <div class="sub-footer text-center pt-3">
          <p class="mb-0">&copy; 2020 ATOZPAY</p>
          <span>Atozpay adalah merek milik PT. Weyland Indonesia Perkasa.</span>
        </div>
      </div>
      <button onclick="topFunction()" aria-label="top" class="btn btn-top hvr-grow" title="Top">
        <i class="fas fa-chevron-up"></i>
      </button>
    </footer>
  </div>
</template>

<script>
    export default {
        name: "Footer"
    };
</script>

<style scoped>

</style>